export function isUrlValid(urlString: string): boolean {
  try {
    const url = new URL(urlString);
    return /[^.]+\.[^.]+/.test(url.hostname);
  } catch {
    return false;
  }
}
